import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IconBookmark16 } from '@app/icons';
import { Button } from '../../../ui/button';
import clsx from 'clsx';

interface Props {
  onClickFavorite: (isFavorite: boolean) => void;
  isFavorite?: boolean;
}

function CardFavoriteButton(props: Props) {
  const { onClickFavorite, isFavorite: propsIsFavorite = false } = props;
  const [isFavorite, setIsFavorite] = useState<boolean>(propsIsFavorite);
  const timeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setIsFavorite(propsIsFavorite);
  }, [propsIsFavorite]);

  const onClickButton = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setIsFavorite(!isFavorite);

      if (timeout.current) {
        clearTimeout(timeout.current);
      }

      timeout.current = setTimeout(() => {
        onClickFavorite(!isFavorite);
      }, 1000);
    },
    [onClickFavorite, isFavorite]
  );

  return (
    <Button
      variant={isFavorite ? 'default' : 'outline'}
      size="icon"
      onClick={onClickButton}
      className={clsx('h-10 w-10 favorite-button', {
        '!bg-white hover:!bg-gray-100 !text-gray-500 !border-gray-300':
          !isFavorite,
        '!bg-primary hover:!bg-primary-hover': isFavorite,
      })}
      type="button"
    >
      <IconBookmark16 />
    </Button>
  );
}

export default CardFavoriteButton;
